import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BankProfile } from '../utils/bank-profile';

@Injectable({
  providedIn: 'root'
})
export class BankDetailService {

  constructor() { }

  private bankObj= new BehaviorSubject({});

  getObject=this.bankObj.asObservable();

  setObject(bankProfileDetail: any){
    this.bankObj.next(bankProfileDetail);
  }
}
